module.exports = __webpack_public_path__ + "static/media/registradores-01.d5be5aa5.jpg";